export const FIRM_SIDS_TO_EXCLUDE_FROM_SESSION_LOGGING = [
  'rentana', // Rentana
]
